import { render, staticRenderFns } from "./report.vue?vue&type=template&id=0a2c06a8&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"
import style0 from "./report.vue?vue&type=style&index=0&id=0a2c06a8&prod&lang=css&scoped=true"
import style1 from "./report.vue?vue&type=style&index=1&id=0a2c06a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c06a8",
  null
  
)

export default component.exports